/* ==========================================================================
   Supabase client.

   Created once here and imported everywhere a real (non-mock) service
   branch needs it. Only ever initialized with the anon/public key — see
   config.ts for why that's safe to ship in the bundle. All actual access
   control lives in supabase/schema.sql (Row Level Security policies and
   the money-moving functions), not in this file or anywhere in the
   frontend.

   Returns null when Supabase isn't configured yet, so a service can fail
   clearly instead of throwing deep inside the Supabase SDK.
   ========================================================================== */

import { createClient, type SupabaseClient } from "@supabase/supabase-js";
import { config } from "../config";

let client: SupabaseClient | null = null;

export function getSupabase(): SupabaseClient {
  if (client) return client;

  if (!config.supabaseUrl || !config.supabaseAnonKey) {
    throw new Error(
      "Supabase isn't configured yet — set window.__PROPERVEST_ENV__.SUPABASE_URL and SUPABASE_ANON_KEY before the bundle loads."
    );
  }

  client = createClient(config.supabaseUrl, config.supabaseAnonKey, {
    auth: {
      persistSession: false, // sessionStore (state/session.ts) is the single source of truth for the session
      autoRefreshToken: true,
    },
  });
  return client;
}

/** Converts a Supabase/PostgREST error into a plain Error with a readable
 *  message, so callers don't need to know PostgrestError's shape. */
export function toError(err: { message: string } | null): Error {
  return new Error(err?.message ?? "Something went wrong talking to the database.");
}
